<template>
  <div id="payment-amounts-wrapper">
    <!-- todo : refactor item tile to accept displays shown -->
    <h4 class="main-body-heading">Choose Amount:</h4>
    <div id="choose-payment-amount-items">
      <item-tile
        v-for="(amount, index) in paymentAmounts"
        :key="index"
        @click="paymentAmountClickHandler(amount)"
        :heading="amount.name"
        :text="amount.amount !== 'input' ? formatPrice(amount.amount) : null"
        :input="amount.amount === 'input'"
        :inputType="amount.amount === 'input' ? 'number' : null"
        @input="setCustomInput"
        inputPlaceholder="$0"
      >
        <p>{{ amount.name }}</p>
        <h3 v-if="amount.amount !== 'input'" class="dollar-amount">
          {{ formatPrice(amount.amount) }}
        </h3>
      </item-tile>
    </div>
    <div class="button-wrapper">
      <!-- todo : refactor primary floating card to include button on top left -->
      <round-button-with-icon
        class="back-arrow"
        icon="left-arrow-single"
        @click="navigateBackward"
      />
      <round-button-with-icon
        v-if="customInputActive"
        icon="circle-checkmark"
        @click="submitPaymentAmount(customAmount)"
      />
    </div>
  </div>
</template>
<script>
import {
  formatPrice,
  balanceOutstanding,
  total,
} from "../../../../../Helpers/invoice.js";
import RoundButtonWithIcon from "../../../RoundButtonWithIcon.vue";
import ItemTile from "../../../ItemTile.vue";

export default {
  data() {
    return {
      customAmount: undefined,
      payeeAccount: undefined,
      stripe: undefined,
    };
  },
  computed: {
    customAmountInput: {
      get() {
        return `${this.currencySymbol}${
          this.customAmount ? this.customAmount : ""
        }`;
      },
      set(val) {
        this.customAmount = val.replace(/[^0-9.-]/g, "");
      },
    },
    customInputActive() {
      return this.customAmount > 1;
    },
    paymentAmounts() {
      let event = this.event;
      let calculateBudgetedAmount = () => {
        let todaysDate = new Date();
        let eventDate = new Date(event.data ? event.data.date : event.date);
        let monthCount =
          eventDate.getMonth() -
          todaysDate.getMonth() +
          12 * (eventDate.getFullYear() - todaysDate.getFullYear());
        if (monthCount <= 0) {
          monthCount = 1;
        }
        return balanceOutstanding(event) / monthCount;
      };
      let depositAmount = (event) => {
        if (this.$store.getters.depositType === "percentage") {
          return (
            parseInt(this.$store.getters.depositAmount) * 0.01 * total(event)
          );
        } else {
          return parseInt(this.$store.getters.depositAmount) * 100;
        }
      };
      if (
        total(event) - balanceOutstanding(event) < depositAmount(event) &&
        balanceOutstanding(event) > 0
      ) {
        return [
          {
            name: "Deposit",
            amount: depositAmount(event),
          },
          {
            name: "Outstanding",
            amount: balanceOutstanding(event),
          },
        ];
      }
      return [
        {
          name: "Budgeted",
          amount: calculateBudgetedAmount(),
        },
        {
          name: "Outstanding",
          amount: balanceOutstanding(event),
        },
        {
          name: "Custom",
          amount: "input",
        },
      ];
    },
    currencySymbol() {
      let currency = this.$store.getters.currencyCode;
      return (0)
        .toLocaleString("lookup", {
          style: "currency",
          currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })
        .replace(/\d/g, "")
        .trim();
    },
  },
  methods: {
    formatPrice,
    setCustomInput(val) {
      this.customAmount = val;
    },
    navigateBackward() {
      this.$emit("navigate-backwards", "choosePaymentType");
    },
    paymentAmountClickHandler(type) {
      if (type.name !== "Custom") {
        this.submitPaymentAmount(type.amount);
      }
    },
    submitPaymentAmount(amount) {
      if (parseInt(amount) > 0) {
        if (this.customInputActive) {
          this.createPaymentIntent(Math.round(amount * 100));
        } else {
          this.createPaymentIntent(Math.round(amount));
        }
      }
    },
    createPaymentIntent(amount) {
      let payload = {
        eventId: this.event.userId,
        tenantId: this.event.tenantId,
        payerName:
          this.$store.state.user.given_name +
          " " +
          this.$store.state.user.family_name,
        payerTenantId: this.$store.state.user.tenantId,
        payerUserId: this.$store.state.user.userId,
        chargeAmount: amount,
        currencyType: this.payeeAccount.default_currency,
        payeeId: this.payeeAccount.id,
      };

      this.$store.dispatch("stripeCreatePaymentIntent", payload).then((res) => {
        this.$emit("payment-intent-created", res);
      });
    },
  },
  async created() {
    this.payeeAccount = await this.$store.dispatch("stripeCheckAccount");
  },
  components: {
    ItemTile,
    RoundButtonWithIcon,
  },
  emits: [
    "navigate-backward",
    "submit-payment-amount",
    "payment-intent-created",
  ],
  props: ["event"],
};
</script>
<style scoped>
#payment-amounts-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-bottom: 20px;
}

.main-body-heading {
  text-transform: unset;
  margin: 30px;
}

#choose-payment-amount-items {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

#choose-payment-amount-items div {
  margin: 10px;
}

.button-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dollar-amount {
  font-size: 18pt;
  margin: 0;
}

#custom-amount-wrapper {
  display: flex;
  justify-content: center;
  max-width: 80%;
}

#custom-amount-input {
  border: none;
  background: none;
  text-align: center;
  padding: 0 0 0 5px;
  max-width: 60%;
}

#custom-amount-input:focus {
  outline: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  position: fixed;
  left: 0;
}

.back-arrow {
  margin: 20px;
  width: 30px;
  height: 30px;
}

@media screen and (min-width: 800px) {
  #payment-amounts-wrapper {
    justify-content: center;
    min-height: 300px;
  }

  .main-body-heading {
    margin: 0 0 30px 0;
  }

  #choose-payment-amount-items {
    flex-direction: row;
    justify-content: space-evenly;
  }
}
</style>
